import { Link } from 'react-router-dom';
import AppPromotionCard from '../AppPromotionCard/AppPromotionCard';
import styles from './Footer.module.css';
import { TMDB_NOTICE } from '../TmdbAttribution/TmdbAttribution';

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                {/* Brand */}
                <div className={styles.brand}>
                    <h3 className={styles.logo}>Aluvo</h3>
                    <p className={styles.tagline}>
                        You’ve watched it. Now prove it.
                    </p>
                </div>

                {/* App promotion */}
                <div className={styles.appPromo}>
                    <AppPromotionCard
                        variant="footer"
                        compact
                        showBenefits={false}
                    />
                </div>

                {/* Links */}
                <div className={styles.links}>
                    <div className={styles.linkGroup}>
                        <h4 className={styles.linkTitle}>Product</h4>
                        <Link to="/how-it-works" className={styles.link}>How it works</Link>
                        <Link to="/rankings/new" className={styles.link}>Create a Ranking</Link>
                        <Link to="/discover?feed=aluvo-picks" className={styles.link}>Aluvo Picks</Link>
                        <Link to="/collections" className={styles.link}>Collections</Link>
                        <Link to="/about" className={styles.link}>About</Link>
                        <Link to="/feedback" className={styles.link}>Give Feedback</Link>
                    </div>

                    <div className={styles.linkGroup}>
                        <h4 className={styles.linkTitle}>Legal</h4>
                        <Link to="/privacy" className={styles.link}>Privacy</Link>
                        <Link to="/terms" className={styles.link}>Terms</Link>
                        <Link to="/delete-account" className={styles.link}>Delete Account</Link>
                    </div>

                    <div className={styles.linkGroup}>
                        <h4 className={styles.linkTitle}>Connect</h4>
                        <a href="mailto:support@aluvo.app" className={styles.link}>Contact</a>
                        <a href="https://x.com/AluvoHQ" target="_blank" rel="noopener noreferrer" className={styles.link}>
                            X (@AluvoHQ)
                        </a>
                    </div>
                </div>

                {/* Copyright */}
                <div className={styles.bottom}>
                    <p className={styles.copyright}>
                        © {currentYear} Aluvo. All rights reserved.
                    </p>
                    {/* TMDB's required notice; the logo is on About → Credits. */}
                    <p className={styles.tmdb}>
                        Movie and TV data and posters from TMDB. {TMDB_NOTICE} <a href="/about#credits">Credits</a>
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
